import { render, staticRenderFns } from "./Tickets.vue?vue&type=template&id=3fad5a97&"
import script from "./Tickets.vue?vue&type=script&lang=js&"
export * from "./Tickets.vue?vue&type=script&lang=js&"
import style0 from "./Tickets.vue?vue&type=style&index=0&id=3fad5a97&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports